import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import StatsCard from '../components/StatsCard';
import SalesChart from '../components/SalesChart';
import RecentOrders from '../components/RecentOrders';
import OrdersPipeline from '../components/OrdersPipeline';
import {api} from '../../api';

export default function Dashboard() {
  const [items, setItems] = useState([]);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api('/items').then(r => r.json()).then(setItems).catch(() => {});
    api('/orders').then(r => r.json()).then(setOrders).catch(() => {});
  }, []);

  const activeOrders = orders.filter(o => !['FULFILLED', 'CANCELLED'].includes(o.status)).length;
  const fulfilledOrders = orders.filter(o => o.status === 'FULFILLED').length;

  return (
    <Layout>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        <StatsCard title="Total Items" value={String(items.length)} />
        <StatsCard title="Total Orders" value={String(orders.length)} />
        <StatsCard title="Active Orders" value={String(activeOrders)} />
        <StatsCard title="Fulfilled" value={String(fulfilledOrders)} />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <SalesChart orders={orders} />
        <OrdersPipeline orders={orders} />
      </div>
      <div className="grid grid-cols-1 gap-6 mb-6">
        <RecentOrders orders={orders} />
      </div>
    </Layout>
  );
}
